import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "results" }

import { DefineProps } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Result',
  props: [
  "quizQuestionLength",
  "numberOfCorrectAnswer",
],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("p", null, "Your Results...", -1)),
    _createElementVNode("h1", null, _toDisplayString(`${__props.numberOfCorrectAnswer}/${__props.quizQuestionLength}`), 1),
    _createVNode(_component_router_link, {
      to: "/",
      class: "text-xl bg-stone-300 p-2 rounded-xl m-4"
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Back")
      ])),
      _: 1
    })
  ]))
}
}

})